import { apiRoutes, createStandardCrudApi } from "./entityApiShared.js";
import type { CrudApi, EntityCreateRequest, EntityRecord, EntityUpdateRequest } from "../types/api.types.js";

export type PermissionDto = EntityRecord;
export type PermissionCreateRequest = EntityCreateRequest;
export type PermissionUpdateRequest = EntityUpdateRequest;

export const permissionApi: CrudApi<PermissionDto, PermissionCreateRequest, PermissionUpdateRequest> = createStandardCrudApi({
  list: apiRoutes.permissions.list,
  get: apiRoutes.permissions.get,
  create: apiRoutes.permissions.create,
  update: apiRoutes.permissions.update,
  delete: apiRoutes.permissions.delete,
});
